module.exports = __webpack_public_path__ + "static/img/logo_m.216b8db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/logo_m.svg
// module id = cnl6
// module chunks = 22